import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './GlobalMomentsSection.css';
import '../common-styles.css';

// Real collage images
// Updated images sourced from global-presense folder (0-* set)
// Layout: left tall spanning two rows; right side top two images, bottom single wide image
const g0_1 = require('../../assets/images/global-presense/0-1.png');
const g0_2 = require('../../assets/images/global-presense/0-2.png');
const g0_3 = require('../../assets/images/global-presense/0-3.png');
const g0_4 = require('../../assets/images/global-presense/0-4.png');

const GlobalMomentsSection: React.FC = () => {
  return (
    <section className="global-moments-section section">
      <Container>
        <Row className="mb-4">
          <Col>
            <div className="text-center">
              <div className="section-badge">EVENTS & EXHIBITIONS</div>
              <h2 className="section-title">
                <span className="section-title-highlight">Global Moments</span>, Brilliant Connections
              </h2>
              <p className="section-description gm-description">
                SunDiam proudly shines on the world stage, showcasing excellence at premier diamond and jewelry exhibitions across the globe. From industry-defining trade shows to exclusive showcases, our presence reflects innovation, craftsmanship, and trust. Each event is an opportunity to connect with clients, partners, and connoisseurs — sharing our passion for brilliance and the future of diamonds.
              </p>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center mb-4">
          <Col lg={11}>
            <div className="gm-collage grid-style">
              <div className="gm-grid-left"><img src={g0_1} alt="Global event highlight" /></div>
              <div className="gm-grid-right-top">
                <div className="gm-top-img"><img src={g0_2} alt="Exhibition interaction" /></div>
                <div className="gm-top-img"><img src={g0_3} alt="Industry gathering" /></div>
              </div>
              <div className="gm-grid-right-bottom"><img src={g0_4} alt="Booth showcase" /></div>
            </div>
            <div className="text-center mt-4">
              <Link to="/global-presence">
                <Button className="section-btn">
                  <span className="btn-content">
                    Explore Our Global Presence <i className="fas fa-arrow-right ms-2 btn-arrow-diagonal" />
                  </span>
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default GlobalMomentsSection;
